<template lang="pug">
.d-liftHome
  .module1
    .title 懂窝客户的家
      .border
    .line1 对家居审美有追求、对生活品质不将就，懂窝客户的家，是我们最好的样板房。<br/> 记录懂窝产品搭配出的丰富生活场景，更记录每个寻常人家的温馨故事。
  .module2
    router-link.item(to="/case8")
      img(src="~assets/lifeHome/img20.jpg")
      .num Vol.08
      .desc 不请设计师，魔都小两口玩转91㎡两房，软装配色美出天际
    router-link.item(to="/case7")
      img(src="~assets/lifeHome/img19.jpg")
      .num Vol.07
      .desc 65㎡精致小户型，处女座男生的神仙日子
    router-link.item(to="/case6")
      img(src="~assets/lifeHome/img2.png")
      .num Vol.06
      .desc 设计师爆改上海50㎡老房，示范小户型改造神操作
    router-link.item(to="/case5")
      img(src="~assets/lifeHome/img3.png")
      .num Vol.05
      .desc 上海93㎡萌趣三口之家，每天都像生活在游乐场
    router-link.item(to="/case4")
      img(src="~assets/lifeHome/img4.png")
      .num Vol.04
      .desc 上海市区一套房，郊外一栋度假屋，生活这样真挺好！
    router-link.item(to="/case3")
      img(src="~assets/lifeHome/img5.png")
      .num Vol.03
      .desc 上海175㎡暗黑系霸道总裁风，花100万装修只为这种feel
    router-link.item(to="/case2")
      img(src="~assets/lifeHome/img6.png")
      .num Vol.02
      .desc 上海246㎡精装大平层，用家具与配饰沉淀出家的味道
    router-link.item(to="/case1")
      img(src="~assets/lifeHome/img7.png")
      .num Vol.01
      .desc 有风景也有爱，建筑师夫妇把140㎡家打造成让人羡慕的样子
  //- .more View More
  .module3
    .title 晒单活动
      .border
    .line1 热爱分享是热爱生活的体现，记录生活点滴时刻，启发更多家居灵感。<br/> 懂窝生活家们，欢迎与我们联系，拍下懂窝产品在您家的使用场景，秀出你的生活你的家。
  .module4
    .item
      .left
        img(src="~assets/lifeHome/icon1.png")
        .line
      .right 途径1：通过<span>天猫晒图</span>，并将相同内容发布到逛逛<br/>途径2：通过<span>小红书晒图并@懂窝</span>
    .item
      .left
        img(src="~assets/lifeHome/icon2.png")
        .line
      .right 天猫：<span>15字以上+3张以上美图/视频</span><br/>小红书：<span>50字以上+3张以上美图/视频</span>
    .item
      .left
        img(src="~assets/lifeHome/icon3.png")
        .line
      .right <span>文字内容生动，能凸显懂窝产品特性</span><br/><span>图片美观，构图清晰，能体现懂窝产品特点</span>
    .item
      .left
        img(src="~assets/lifeHome/icon4.png")
      .right <span>天猫晒单：将晒单截图给天猫客服，即享20元现金红包；实付1500元-5000元的订单即享50元现金红包；实付5000元以上即享1%返现。</span><br/><span>其他渠道晒单：将晒单截图给对接搭配师，即享20元现金红包；实付1500元-5000元的订单即享50元现金红包；实付5000元以上即享1%返现。</span>
  .module5
    .item
      img(src="~assets/lifeHome/s1-img1.jpg")
      .text <span>来自懂窝屋主<br/> @华先生</span><br/> 伊丽莎白Elizabeth沙发<br/> 娜塔莎Natasha双人床<br/>巴罗Barrow沙发
      img(src="~assets/lifeHome/s1-img2.png")
      .text <span>来自懂窝屋主<br/> @Tracy</span><br/>莱拉 Leila 书桌
      img(src="~assets/lifeHome/s1-img3.png")
      .text <span>来自懂窝屋主<br/> @h**y</span><br/> 丹维尔Danville沙发
      img(src="~assets/lifeHome/s1-img4.png")
      .text <span>来自懂窝屋主<br/> @赵小姐</span><br/> 瑞森Riesen餐椅<br/> 彭特Puente餐桌
      img(src="~assets/lifeHome/s1-img5.png")
      .text <span>来自懂窝屋主<br/> @赵女士</span><br/> 巴罗Barrow沙发
      img(src="~assets/lifeHome/s1-img6.png")
      .text <span>来自懂窝屋主<br/> @周小姐</span><br/> 埃尔温Erwin沙发
    .item
      img(src="~assets/lifeHome/s2-img1.jpg")
      .text <span>来自懂窝屋主<br/> @陈小姐</span><br/> 弗雷德里克 Frederik 沙发 <br/> 海尔格 Helgar 羽毛落地灯
      img(src="~assets/lifeHome/s2-img2.png")
      .text <span>来自懂窝屋主<br/> @香り</span><br/> 艾尔弗雷德 Alfred 地灯
      img(src="~assets/lifeHome/s2-img3.png")
      .text <span>来自懂窝屋主<br/> @宫小姐</span><br/> 普莱森顿 Pleasanton 沙发
      img(src="~assets/lifeHome/s2-img4.png")
      .text <span>来自懂窝屋主<br/> @李小姐</span><br/> 埃尔温Erwin沙发
      img(src="~assets/lifeHome/s2-img5.png")
      .text <span>来自懂窝屋主<br/> @孙女士</span><br/> 埃尔温Erwin沙发
    .item
      img(src="~assets/lifeHome/s3-img1.jpg")
      .text <span>来自懂窝屋主<br/> @罗小姐 </span><br/> 杰洛德Jarrod布艺沙发 <br> 琳内尔Linnell双人床
      img(src="~assets/lifeHome/s3-img2.png")
      .text <span>来自懂窝屋主<br/>  @Bingxin </span><br/>  巴罗 Barrow 沙发 <br> 拉里亚 Llaria 地灯
      img(src="~assets/lifeHome/s3-img3.png")
      .text <span>来自懂窝屋主<br/> @欧先生 </span><br/> 普莱森顿 Pleasanton 沙发
      img(src="~assets/lifeHome/s3-img4.png")
      .text <span>来自懂窝屋主<br/> @陈先生 </span><br/> 巴罗 Barrow 沙发
      img(src="~assets/lifeHome/s3-img5.png")
      .text <span>来自懂窝屋主<br/> @王女士 </span><br/> 巴罗 Barrow 沙发
      img(src="~assets/lifeHome/s3-img6.png")
      .text <span>来自懂窝屋主<br/> @郑女士 </span><br/> 埃尔温Erwin沙发
  .module6
    .title 客户口碑反馈
      .border
    .line1 口碑源于产品和服务，懂窝成立以来深受客户喜爱，在小红书、大众<br/>点评等平台拥有超高人气口碑，连续位列大众点评上海地区成品家具前三。感谢您的反馈，帮助我们持之以恒做得更好。
  .module7
    .swiper-container
      .swiper-wrapper
          .swiper-slide
            img(src="~assets/lifeHome/swiper1.png")
          .swiper-slide
            img(src="~assets/lifeHome/swiper2.png")
          .swiper-slide
            img(src="~assets/lifeHome/swiper3.png")
          .swiper-slide
            img(src="~assets/lifeHome/swiper4.png")
          .swiper-slide
            img(src="~assets/lifeHome/swiper5.png")
      .swiper-pagination
      .swiper-button-prev
      .swiper-button-next
  img.scroll-top-btn(v-show="scrollTop", @click="backtop", src="~assets/goTop.png")
</div>
</template>

<script>
export default {
  data() {
    return {
      scrollTop: false
    };
  },
  created() {},
  mounted() {
    this.$nextTick(()=>{
      var mySwiper = new Swiper(".swiper-container", {
        paginationClickable: true,
        loop: true,
        speed: 500,
        // autoplay: 2200,
        autoplayDisableOnInteraction: false,
        nextButton: ".swiper-button-next",
        prevButton: ".swiper-button-prev",
        // // 如果需要分页器
        // pagination: ".swiper-pagination",
        effect: "slide",
        onInit: function(swiper) {
          // swiper加载完毕
        }
      });
    })
    window.addEventListener("scroll", this.showbtn, true);
  },
  methods: {
    // 显示回到顶部按钮
    showbtn() {
      let that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
    },
    /**
     * 回到顶部功能实现过程：
     * 1. 获取页面当前距离顶部的滚动距离（虽然IE不常用了，但还是需要考虑一下兼容性的）
     * 2. 计算出每次向上移动的距离，用负的滚动距离除以5，因为滚动的距离是一个正数，想向上移动就是做一个减法
     * 3. 用当前距离加上计算出的距离，然后赋值给当前距离，就可以达到向上移动的效果
     * 4. 最后记得在移动到顶部时，清除定时器
     */
    backtop() {
      var timer = setInterval(function() {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    }
  }
};
</script>

<style lang="sass" scoped>
@import 'config'
.d-liftHome
  width: 100%
  .module1
    width: 100%
    height: r(855)
    padding-top: r(319)
    background: url('~assets/lifeHome/img1.png') no-repeat center / cover
    .title
      width: 100%
      font-family: PingFangSC-Medium
      font-size: r(40)
      color: #FEFFFF
      text-align: center
      .border
        margin: r(40) auto 0
        width: r(42)
        height: r(4)
        background: #ffffff
    .line1
      margin-top: r(54)
      width: 100%
      font-family: PingFangSC-Medium
      font-size: r(25)
      color: #FEFFFF
      text-align: center
      line-height: r(42)
  .module2
    margin: r(182) auto 0
    width: r(1122)
    display: flex
    justify-content: space-between
    flex-wrap: wrap
    .item
      margin-bottom: r(94)
      width: r(541)
      img
        width: 100%
      .num
        margin-top: r(30)
        font-family: PingFangSC-Regular
        font-size: r(20)
        color: #717273
      .desc
        font-family: PingFangSC-Medium
        font-size: r(20)
        color: #000001
        line-height: r(32)
  .more
    margin: r(26) auto 0
    width: r(171)
    height: r(42)
    border: 1px solid #595757
    font-family: ArialMT
    font-size: r(22)
    color: #002727
    line-height: r(42)
    text-align: center
  .module3
    margin-top: r(182)
    width: 100%
    height: r(855)
    padding-top: r(319)
    background: url('~assets/lifeHome/img8.png') no-repeat center / cover
    .title
      width: 100%
      font-family: PingFangSC-Medium
      font-size: r(40)
      color: #FEFFFF
      text-align: center
      .border
        margin: r(40) auto 0
        width: r(42)
        height: r(4)
        background: #ffffff
    .line1
      margin-top: r(54)
      width: 100%
      font-family: PingFangSC-Medium
      font-size: r(25)
      color: #FEFFFF
      text-align: center
      line-height: r(42)
  .module4
    margin: r(190) auto 0
    width: r(980)
    .item
      width: 100%
      display: flex
      justify-content: space-between
      .left
        width: r(74)
        display: flex
        align-items: center
        flex-direction: column
        img
          display: block
          width: r(74)
        .line
          margin: r(34) 0 r(24)
          width: r(1)
          height: r(100)
          border: 1px dashed  #808080
      .right
        width: r(858)
        font-family: PingFangSC-Regular
        font-size: r(20)
        color: #363738
        line-height: r(32)
        span
          font-family: PingFangSC-Medium
          color: #18191A
  .module5
    margin: r(135) auto 0
    width: r(1122)
    display: flex
    justify-content: space-between
    .item
      width: r(366)
      img
        width: r(366)
      .text
        margin-top: r(28)
        margin-bottom: r(60)
        font-family: PingFangSC-Regular
        font-size: r(20)
        color: #2B2C2D
        text-align: center
        line-height: r(33)
        padding-top: 0.1px
        span
          display: block
          margin-bottom: r(20)
          font-family: PingFangSC-Medium
          font-size: r(22)
          color: #000001
  .module6
    margin-top: r(180)
    width: 100%
    height: r(855)
    padding-top: r(319)
    background: url('~assets/lifeHome/img18.png') no-repeat center / cover
    .title
      width: 100%
      font-family: PingFangSC-Medium
      font-size: r(40)
      color: #FEFFFF
      text-align: center
      .border
        margin: r(40) auto 0
        width: r(42)
        height: r(4)
        background: #ffffff
    .line1
      margin-top: r(54)
      width: 100%
      font-family: PingFangSC-Medium
      font-size: r(25)
      color: #FEFFFF
      text-align: center
      line-height: r(42)
  .module7
    margin: r(283) auto
    width: r(1300)
    .swiper-container
      width: 100%
      .swiper-wrapper
        width: 100%
        .swiper-slide
          width: 100% !important
          img
            display: block
            margin: 0 auto
            width: r(1120)
      .swiper-button-prev
        width: r(24)
        height: r(45)
        background-image: url('~assets/icon-left.png')
        background-size: cover
      .swiper-button-next
        width: r(24)
        height: r(45)
        background-image: url('~assets/icon-right.png')
        background-size: cover
  .scroll-top-btn
    position: fixed
    z-index: 100
    bottom: r(100)
    right: r(100)
    width: r(80)
</style>



// WEBPACK FOOTER //
// lifeHome.vue?63628394